// Recognizes overflow to display text on hover in a tooltip
import { useRef, useState, useEffect } from 'react';
export function useTextOverflow(children) {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const checkOverflow = () => {
            const isOverflowing = element.offsetWidth < element.scrollWidth;
            setIsOverflowing(isOverflowing);
        };
        // Defer checking overflow until after next paint
        requestAnimationFrame(() => {
            requestAnimationFrame(checkOverflow);
        });
    }, [children]);
    return [ref, isOverflowing];
}
